import React from 'react';

export default ({ onChange, onFocus, onBlur, value }) => {
    return <input type="number" min="0" max="100" value={value ? value : ""} onChange={ onChange  } onFocus={onFocus} onBlur={onBlur} />
}


// WEBPACK FOOTER //
// ./src/HrcsEditor/input/PercentageInput.js